import { Injectable } from '@angular/core';

import { NotificationTopicSchemaPartnerUserSubMaintenanceController } from './NotificationTopicSchemaPartnerUserSubMaintenanceController';

@Injectable()
export class NotificationTopicSchemaPartnerLogisticOperatorUserSubMaintenanceController extends NotificationTopicSchemaPartnerUserSubMaintenanceController {

    public getResourceRoot(): string {
        return "NOTIFICATIONTOPICSCHEMAPARTNER.USER.LOGISTICOPERATOR";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/partner/logisticoperator/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}